import { RankmiTable } from '@rankmi/rankmi-table'

import type { IRankmiTable } from '@rankmi/rankmi-table/dist/interfaces/tableProps'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { UsersFilterOptions } from 'enum/users-filter-options.enum'
import { generateTableLocale } from 'helpers/translations.helper'

const prefix = 'configuration.users.list'

const translateFiltersPrefix = `${prefix}.filters`

const TableUsers = (props: IRankmiTable) => {
  const { t } = useTranslation()

  const translations = useMemo(
    () =>
      generateTableLocale({
        header: {
          rowsCount_plural: t(`${prefix}.rowsCount_plural`),
          rowsCount: t(`${prefix}.rowsCount`),
          allParticipants: t(`${translateFiltersPrefix}.noFilter`),
          addButton: t(`${prefix}.addButton`),
        },
      }),
    [t]
  )

  const fastActions = [
    {
      label: t(`${translateFiltersPrefix}.withProfiles`),
      value: UsersFilterOptions.withProfiles,
    },
    {
      label: t(`${translateFiltersPrefix}.noProfiles`),
      value: UsersFilterOptions.noProfiles,
    },
    {
      label: t(`${translateFiltersPrefix}.admins`),
      value: UsersFilterOptions.admins,
    },
  ]
  return (
    <RankmiTable
      {...props}
      fastActions={props?.fastActions || fastActions}
      locale={props?.locale || translations}
    />
  )
}

export default TableUsers
